/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import PropTypes from "prop-types";
import { Divider } from "@blueprintjs/core";
import { Row } from "jsxstyle";
import Button from "components/Button";
import Card from "components/Card";
import Separator from "components/Separator";
import TwoColumnFormLayout from "components/TwoColumnFormLayout";
import CMBSRatingAgenciesForm from "./CMBSRatingAgenciesForm";
import CMBSRatingAgenciesTable from "./CMBSRatingAgenciesTable";
import useAsync from "hooks/useAsync";
import loadCMBSRatingsService from "services/cmbs/loadCMBSRatingsService";
import PermissionValidator from "components/PermissionValidator";
import { ADMIN_ROLE, DATA_TEAM_ROLE } from "consts";
import browserHistory from "browserHistory";

function CMBSRatingAgenciesTab({ deal, isNew }) {
  const [agencyToEdit, setAgencyToEdit] = React.useState(null);

  const dealCode = deal.deal_code;

  const [fetch, pending, data] = useAsync({
    promiseFn: loadCMBSRatingsService,
  });

  React.useEffect(() => {
    fetch({ dealCode });
  }, []);

  return (
    <Card>
      <PermissionValidator allowedFor={[ADMIN_ROLE, DATA_TEAM_ROLE]}>
        <TwoColumnFormLayout
          title={agencyToEdit ? "Edit Rating Agency" : "Add Rating Agency"}
        >
          <CMBSRatingAgenciesForm
            key={agencyToEdit && agencyToEdit.id}
            onCancel={() => setAgencyToEdit(null)}
            onData={() => {
              setAgencyToEdit(null);
              fetch({ dealCode });
            }}
            initialValues={{
              dealCode,
              ...(agencyToEdit
                ? {
                    ...agencyToEdit,
                    entity_id: agencyToEdit.entity_id.entity_id,
                  }
                : {}),
            }}
          />
        </TwoColumnFormLayout>
        <Divider style={{ margin: "30px 0 30px 0" }} />
      </PermissionValidator>
      <TwoColumnFormLayout title="Rating Agencies">
        <CMBSRatingAgenciesTable
          data={data}
          pending={pending}
          onReload={() => fetch({ dealCode })}
          onRequestEdit={(agency) => setAgencyToEdit(agency)}
        />
      </TwoColumnFormLayout>
      {isNew && (
        <React.Fragment>
          <Separator size="lg" />
          <Row className="col-12" justifyContent="flex-end">
            <Button
              intent="primary"
              text="Next"
              onClick={() =>
                browserHistory.push(`/cmbs/new/${deal.deal_code}/borrowers`)
              }
            />
          </Row>
        </React.Fragment>
      )}
    </Card>
  );
}

CMBSRatingAgenciesTab.propTypes = {
  isActive: PropTypes.bool,
  dealCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  isNew: PropTypes.bool,
};

CMBSRatingAgenciesTab.defaultProps = {
  isActive: false,
  isNew: true,
};

export default CMBSRatingAgenciesTab;
